export async function tryShareImageWithHashtags(imageUrl, hashtags) {
  if (typeof navigator === 'undefined' || typeof window === 'undefined') {
    return false;
  }

  try {
    const response = await fetch(imageUrl, { mode: 'cors' });
    if (!response.ok) {
      throw new Error('Failed to download image');
    }

    const blob = await response.blob();
    const fileName = imageUrl.split('/').pop() || 'sportivos-progress.jpg';
    const fileType = blob.type || 'image/jpeg';
    const shareFile = new File([blob], fileName, { type: fileType });

    if (typeof navigator.canShare === 'function' && navigator.canShare({ files: [shareFile] })) {
      await navigator.share({
        files: [shareFile],
        text: hashtags,
        title: 'Mi progreso en Sportivos Gym',
      });
      return true;
    }
  } catch (error) {
    // Ignore and fallback to manual flow
  }

  return false;
}

export async function copyTextToClipboard(text) {
  if (typeof navigator !== 'undefined' && navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (error) {
      // Fallback to manual element below
    }
  }

  if (typeof document === 'undefined') {
    return false;
  }

  const textArea = document.createElement('textarea');
  textArea.value = text;
  textArea.setAttribute('readonly', '');
  textArea.style.position = 'absolute';
  textArea.style.left = '-9999px';
  document.body.appendChild(textArea);
  const selection = document.getSelection();
  if (selection && selection.rangeCount > 0) {
    selection.removeAllRanges();
  }
  textArea.select();
  let success = false;
  try {
    success = document.execCommand('copy');
  } catch (error) {
    success = false;
  }
  document.body.removeChild(textArea);
  return success;
}

export async function downloadImage(imageUrl, filename = 'sportivos-progress.jpg') {
  if (typeof document === 'undefined') {
    return false;
  }

  try {
    const response = await fetch(imageUrl, { mode: 'cors' });
    if (!response.ok) {
      throw new Error('Failed to download image');
    }
    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(blobUrl);
    return true;
  } catch (error) {
    return false;
  }
}
